import React from "react";
import { Container } from "react-bootstrap";
import FooterContent from "../../FooterContent";

const ReturnsAndExchange = () => {
  return (
    <div className="returnsandexchange">
      <Container>
        <div className="title mb-20">Returns & Exchange</div>
        <div className="table-content">
          <div className="title-wraper">
            <div className="table-title">Returns & Exchange</div>
          </div>
          <FooterContent />
        </div>
      </Container>
    </div>
  );
};

export default ReturnsAndExchange;
